// extracted by mini-css-extract-plugin
export var button = "_oj-0";